import { setLocationPath } from '@/store/locationSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

function LocationTracker() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLocationPath(location.pathname));
    // eslint-disable-next-line
  }, [location.pathname]);

  return null; // This component doesn't render anything
}

export default LocationTracker;
